module.exports = __webpack_public_path__ + "static/media/skills.9959cfdc.svg";